<div class="row" *ngIf="widgetType">
  <div class="col-lg-3">
    <div class="form-group input-group-sm">
      <label>Name</label>
      <input type="text" placeholder="name" class="form-control" [(ngModel)]="w.name"/>
    </div>
  </div>
  <div class="col-lg-3">
    <div class="form-group input-group-sm">
      <label>Type</label>
      <select [(ngModel)]="w.gaugeType" class="input-group form-select">
        <option value="solid">Solid</option>
        <option value="speedometer">Speedometer</option>
        <option value="horizontal">Horizontal Bar</option>
        <!--<option value="vumeter">VU Meter</option>-->
      </select>
    </div>
  </div>
  <div class="col-lg-3">
    <div class="form-group input-group-sm">
      <label>Period</label>
      <app-time-period [(period)]="w.period" [type]="'text'"></app-time-period>
    </div>
  </div>
  <div class="col-lg-3">
    <div class="form-group input-group-sm">
      <label>Refresh (Seconds)</label>
      <input min="60" type="text" placeholder="refresh interval" class="form-control" [(ngModel)]="w.refreshInterval"/>
    </div>
  </div>
  <div class="col-lg-3">
    <div class="form-group input-group-sm">
      <label>Widget Size</label>
      <select [(ngModel)]="w.size" class="form-select">
        <option value="1">1</option>
        <option value="2">2</option>
        <option value="3">3</option>
        <option value="4">4</option>
        <option value="5">5</option>
        <option value="6">6</option>
        <option value="12">12</option>
      </select>
    </div>
  </div>
  <div class="col-lg-3">
    <div class="form-group input-group-sm">
      <input type="checkbox" [(ngModel)]="widget.showTitle" /> Show Title
    </div>
    <div class="form-group input-group-sm">
      <input type="checkbox" [(ngModel)]="widget.showLabel" /> Show Label
    </div>
     <div class="form-group input-group-sm">
      <input type="checkbox" [(ngModel)]="widget.showValue" /> Show Value
    </div>
  </div>
</div>
<br/>
<br/>
<div class="row mb-3">
  <div class="col-lg-3">
    <button (click)="addItem()" class="btn btn-primary btn-block" type="submit" [disabled]="w.timeSeriesDetailList && w.timeSeriesDetailList.length >= 4">
      <i class="fa fa-line-chart"></i> Add Time Series
    </button>
  </div>
</div>

<div class="row" *ngIf="widgetType && w && w.timeSeriesDetailList">
  <div class="col-lg-12">
    <tabset>
      <tab
        *ngFor="let tab of w.timeSeriesDetailList"
        [heading]="tab.uri == null ? 'Not Set' : tab.name == '' || tab.name == null ? tab.uri : tab.name"
        [active]="tab.active"
        (select)="tab.active = true"
        (deselect)="tab.active = false"
        [disabled]="tab.disabled"
        [removable]="tab.removable"
        (removed)="removeTimeSeries(tab)">

        <div class="row">
          <div class="col-lg-5">
            <div class="form-group input-group-sm">
              <label>Select Time Series</label>
              <app-uri-select [customerId]="dashboard.customerId" [timeSeriesDetail]="tab" [enableMediaSearch]="false" [enableTagMatch]="true" [siteTypeCode]="dashboard.siteType" [siteUri]="siteUri"></app-uri-select>
              <!--<app-time-series-select [timeSeriesDetail]="tab" [enableTagMatch]="true"></app-time-series-select>-->
            </div>
            <div class="form-group input-group-sm">
              <label>Display Name</label>
              <input type="text" size="20" [(ngModel)]="tab.name" class="form-control">
            </div>
            <div class="form-group input-group-sm">
              <label>Data Range</label>
              <input type="text" placeholder="min" class="form-control" [(ngModel)]="tab.min"/>
              <span class="input-group-addon">-</span>
              <input type="text" placeholder="max" class="form-control" [(ngModel)]="tab.max"/>
            </div>
            <div class="form-group input-group-sm">
              <label>Value Suffix</label>
              <input type="text" [(ngModel)]="tab.valueSuffix" class="input-group form-control"/>
            </div>
            <div class="form-group">
              <app-transform-editor [transforms]="tab.transforms"></app-transform-editor>
            </div>
          </div>
          <div class="col-lg-7">
            <div class="row mt-3">
              <div class="col-lg-12">
                <tabset>
                  <tab heading="Zone Color">
                      <div class="row mt-3">
                        <div class="col-lg-12">
                          <div class="form-group input-group-sm">
                            <table class="table">
                                <tr>
                                  <th>
                                    <label>Zone Min</label>
                                  </th>
                                  <th>
                                    <label>Zone Max</label>
                                  </th>
                                  <th>Colour</th>
                                  <th>Plot Line</th>
                                  <th><a (click)="addZoneColor(tab)"><i class="fa fa-plus"></i></a></th>
                                </tr>
                                <tr *ngIf="tab.zoneColours == null || tab.zoneColours.length == 0">
                                    <td colspan="3">No Zone Colors</td>
                                </tr>
                                <tr *ngFor="let zoneObj of tab.zoneColours">
                                  <td>
                                    <input type="number" [(ngModel)]="zoneObj.min" class="input-group form-control"/>
                                  </td>
                                  <td>
                                    <input type="number" [(ngModel)]="zoneObj.max" class="input-group form-control"/>
                                  </td>
                                  <td>
                                    <button [style.background]="zoneObj.colour" [cpPosition]="'top'" [(colorPicker)]="zoneObj.colour" [cpPresetLabel]="'Standard'" [cpPresetColors]="colours" select="colour-picker-button"></button>
                                  </td>
                                  <td>
                                    <div class="form-group input-group-sm">
                                      <input type="checkbox" [(ngModel)]="zoneObj.showPlotLine" />
                                    </div>
                                  </td>
                                  <td>
                                      <a (click)="removeZoneColour(tab, zoneObj)"><i class="fa fa-minus"></i></a>
                                  </td>
                                </tr>
                            </table>
                          </div> 
                        </div>
                      </div>
                  </tab>
                </tabset>
              </div>
            </div>
          </div>
        </div>  
      </tab>
    </tabset>
  </div>
</div>  
  
